import { Box, Divider, Fab, Stack, SwipeableDrawer } from "@mui/material"
import { ReactElement, useState } from "react"

import ReleaseNote from "./releaseNote"
import ReleasePanel from "./releasePanel"
import { RELEASE_MIGRATION } from "./releases/migration"
import AppPaper from "../../components/surfaces/appPaper"
import DisplayIf from "../../components/wrappers/displayIf"
import { SIDE_BAR_NON_MOBILE_WIDTH } from "../../constants/generalConstants"
import { FAB_POSITION_DISPATCHER } from "../../constants/positioning"
import { useScreenSize } from "../../hooks/useScreenSize"

const Changelog = (): ReactElement => {
    const [selectedRelease, setSelectedRelease] = useState(RELEASE_MIGRATION)
    const { isTabletOrMob, isMob } = useScreenSize()
    const [isMobDrawerOpen, setIsMobDrawerOpen] = useState(false)

    return (
        <AppPaper>
            <SwipeableDrawer
                anchor="right"
                open={isMobDrawerOpen}
                onClose={() => setIsMobDrawerOpen(false)}
                onOpen={() => ({})}
            >
                <Box
                    padding={4}
                    width={isMob ? "100vw" : SIDE_BAR_NON_MOBILE_WIDTH}
                    sx={{
                        backgroundColor: "background.contentBackground",
                        overflowY: "auto",
                        height: "100%",
                    }}
                >
                    <ReleasePanel
                        setSelectedRelease={setSelectedRelease}
                        selectedRelease={selectedRelease}
                    />
                </Box>
            </SwipeableDrawer>
            <Stack direction="row" spacing={{ xs: 0, md: 10 }}>
                <DisplayIf condition={!isTabletOrMob}>
                    <>
                        <ReleasePanel
                            setSelectedRelease={setSelectedRelease}
                            selectedRelease={selectedRelease}
                        />
                        <Divider orientation="vertical" flexItem />
                    </>
                </DisplayIf>
                <DisplayIf condition={isTabletOrMob}>
                    <Fab
                        variant="extended"
                        color="primary"
                        onClick={() => setIsMobDrawerOpen(true)}
                        sx={{
                            ...FAB_POSITION_DISPATCHER[0],
                            textTransform: "none",
                        }}
                    >
                        Select
                    </Fab>
                </DisplayIf>
                <ReleaseNote release={selectedRelease} />
            </Stack>
        </AppPaper>
    )
}

export default Changelog
